<template>
  <a-popover
    v-model:open="localPopoverIsOpen"
    :trigger="loading || disabled || isFake ? '' : 'click'"
    placement="bottomRight"
    :arrow="false"
    class="popover"
    :overlayClassName="isFake ? 'fake' : ''"
    @visible-change="handleVisibleChange"
  >
    <template #content>
      <slot></slot>
    </template>
    <div
      :class="{ disabled: disabled || loading }"
      :style="{ cursor: disabled || loading ? 'default' : 'pointer' }"
    >
      <a-flex
        align="center"
        justify="center"
        gap="small"
        style="padding: 0.5em 0"
      >
        <span
          style="
            font-weight: 700;
            text-wrap: nowrap;
            user-select: none;
            overflow: hidden;
            text-overflow: ellipsis;
          "
        >
          {{ mainButtonText }}
        </span>
        <img
          :src="downArrowImg"
          :alt="
            localPopoverIsOpen
              ? 'Иконка: стрелки вверх'
              : 'Иконка: стрелки вниз'
          "
          :class="{ rotated: localPopoverIsOpen }"
          v-if="!loading"
        />
        <SyncOutlined class="loading" spin v-else />
      </a-flex>
    </div>
  </a-popover>
</template>

<script setup lang="ts">
import downArrowImg from "@/assets/images/2-arrow-down.svg";
import { ref, watch } from "vue";
import { SyncOutlined } from "@ant-design/icons-vue";

type PopoverMenuProps = {
  mainButtonText: string;
  isFake?: boolean;
  disabled?: boolean;
  loading?: boolean;
};

const props = defineProps<PopoverMenuProps>();
const popoverIsOpen = defineModel<boolean>("popoverIsOpen", { default: false });

const localPopoverIsOpen = ref(false);

watch(popoverIsOpen, (newValue) => {
  localPopoverIsOpen.value = newValue;
});

const handleVisibleChange = (visible: boolean) => {
  if (!props.isFake) {
    localPopoverIsOpen.value = visible;
    popoverIsOpen.value = visible;
  }
};
</script>

<style scoped lang="scss">
img {
  transition: transform 0.3s ease;
}

.popover {
  flex-shrink: 0;
}

img.rotated {
  transform: rotate(180deg);
}

.disabled {
  opacity: 70%;
}

.loading {
  font-size: 19px;
  line-height: 1;
  color: var(--color-primary);
}
</style>
